import React, { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { httpService } from '@flexo/general';
import { useDispatch } from 'react-redux';
import { METADATA, ALERT } from '@flexo/reducers';

const ENV = (import.meta as any).env;


export const CommunitiesResolver = React.memo((props: any) => {

  const dispatch = useDispatch();
  const { t } = useTranslation();

  async function init() {
    // Token auto-injected by httpService interceptor
    const [communities] = await Promise.all([
      httpService.get({
        url: `${ENV.VITE_APP_BASE_URL}/community/catalog/v1_3/organization/${ENV.VITE_APP_ORG_ID}/communities`,
      })
        .then((res: any) => {
          if (res.status === 200) {
            return res.data.communities;
          } else {

            dispatch(ALERT.SetAlert({
              value: {
                type: 'BANNER_UNEXPECTED_ERROR'
              },
            } as any));

            return null;
          }
        })
        .catch((err: any) => {

          dispatch(ALERT.SetAlert({
            value: {
              type: 'BANNER_UNEXPECTED_ERROR'
            },
          } as any));

          return null;
        }),
    ]);

    dispatch(METADATA.SetCommunities(communities) as any);

  }


  useEffect(() => {
    dispatch(METADATA.ClearSelectedEntity());
    dispatch(METADATA.ResetAllFilters());
    init();
  }, []);

  return <></>;

});